// extracted by mini-css-extract-plugin
export default {"innerContainer":"deviceAccess_innerContainer__MJ3EZ","appCard":"deviceAccess_appCard__uI62K","left":"deviceAccess_left__GA6Ws","right":"deviceAccess_right__Oeexi"};